(function () {
  const SELECTOR = 'a.cloud-search-page-controls__filters-link';
  const CLASSES = ['btn', 'btn--secondary', 'gap-2'];

  function applyClasses() {
    document.querySelectorAll(SELECTOR).forEach(function (btn) {
      const missing = CLASSES.filter(function (name) {
        return !btn.classList.contains(name);
      });

      if (missing.length) btn.classList.add(...missing);
    });
    document.querySelectorAll('.cloud-search-filter__name > span:last-child').forEach(function (span) {
      if (!span.classList.contains('h6')) {
        span.classList.add('h6');
      }
    });
  }

  function init() {
    new MutationObserver(applyClasses).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    applyClasses();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();